<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img">
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">我的金币</div>
      <div class="nav-right" @click="goto_coindtl()">
        <span class="nav-lable">账单</span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none">
      </div>
    </div>

    <transition name="fade">
      <div class="dy-photo" v-show="show">
        <img :src="dy_photo" />
      </div>
    </transition>

    <div class="top">
      <div class="info-blcok">
      
        <img :src="user_info.photo" class="vip-img" />
        
        <div class="info-nick">
          <span class="sp-nick">{{user_info.nick}}</span>
          <div v-if="sex == '男生'" class="ub ub-ac ub-pc sp-tip">
            <span>金币在手，不怕小姐姐不跟你走~</span>
          </div>
          <div v-if="sex == '女生'" class="ub ub-ac ub-pc sp-tip">
            <span>金币在手，不怕小哥哥不跟你走~</span>
          </div>
        </div>
      </div>

      <div class="goto">
        <img src="../../assets/img/金币.png" class="coin-left-img" />
        <span class="coin-left-name">剩余金币：</span><label class="coin-left">{{ coin_left }}</label>
      </div>
    </div>

    <ul class="menu-block">
      <li v-if="user_info.vip_level > 0">
        <div class="ub ub-pc menu-item">
          <img src="../../assets/img/金币.png" class="menu-item-img">
          <div class="ub-f1 ub-ae menu-item-neme">{{vip_rights.coin}}个<span class="item-fz">({{ vip_rights.tip }})</span></div>
          <div class="ub ub-ac ub-pc menu-item-btn" v-if="vip_rights.state == 2" @click="receive_coin(vip_rights)">领取</div>
          <div class="ub ub-ac ub-pc menu-item-btn3" v-if="vip_rights.state == 3">已领取</div>
        </div>
        <div class="menu-line"></div>
      </li>
      <li v-for="(item,index) in  arr" :key="index">
        <div class="ub ub-pc menu-item">
          <img src="../../assets/img/金币.png" class="menu-item-img">
          <div class="ub-f1 ub-ae menu-item-neme">{{item.brife}} <span v-if="item.cm" class="item-fz">({{item.cm}})</span></div>
          <div class="ub ub-ac ub-pc menu-item-btn" @click="pay_coin(item.coin, item.mny)">￥{{item.mny}}</div>
        </div>
        <div class="menu-line"></div>
      </li>
    </ul>

    <div class="pay-note">
      <p>
        <span class="tag"></span><span>虚拟产品购买后不可退换</span>
      </p>
      <p>
        <span class="tag"></span><span>未成年请在家长陪同下充值</span>
      </p>
      <p>
        <span class="tag"></span><span>为了保障您的资金安全，当前只支持微信环境下支付</span>
      </p>
    </div>
    <dlg ref="myForm" @formBehavior="formBehaviorFun"></dlg>
  </div>
</template>

<script>
  import { mapMutations, mapActions } from "vuex";
  import Form from '../../components/Form.vue';
  import * as tool from '../../api/common';
  export default {
    components: {
      'dlg': Form
    },
    data() {
      return {
        user_info:{
        'nick':'仙女爷爷',
        'photo':'../../assets/img/vip.png'
        },
        coin_left: 5000,
        sex: '男生',
        arr: [],

        show: false,
        dy_photo: '',
        arr_photo: [],
        theme_dark: false,
        vip_rights: {
          "task_type": 6,
          "coin": 1000,
          "state": 2,
          "tip": "会员用户免费领取"
        },
      };
    },

    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.init_page();
    },
    methods: {
      ...mapMutations(['get', 'post', 'WxConfig', 'WxPay']), //引入方法
      ...mapActions(["act_get_userinfo", "act_reload_userinfo"]), //引入方法

      back() {
        this.$router.go(-1); //返回上一层
      },
      goto_coindtl() {
        this.$router.push({ name: "coindtl" });
      },
      init_page() {
       this.WxConfig({url:window.location.href});

        //加载业务数据
        var self = this;
        var uid = self.$store.state.uid;
        this.act_get_userinfo({
          uid: uid,
          success: function (u) {
            self.coin_left = u.coin_left;
            if (self.coin_left < 0) {
              self.coin_left = 0;
            }
            self.sex = u.sex;
            self.user_info = u;
          }
        });

        self.get({
          url: '/App/GetCnfigCoin/?uid=' + uid,
          success: function (data) {
            self.arr = data;
          }
        });

        //获取会员权益领取状态
        self.get({
            url: "/App/GetTaskCoinState?uid=" + uid,
            success: function (data) {
              var task_vip = data.filter(item=> item.type_dtl == "任务奖励-会员");
              if (task_vip.length > 0) {
                self.vip_rights.state = 3;
              }
            },
            error: function (err){}
          });

      },

      init_page_arrPhoto(sex) {
        var self = this;
        var count = 30;
        sex = (sex == '男生' ? '女生' : '男生');
        self.get({
          url: '/App/GetPhotoGood/?count=' + count + "&sex=" + sex,
          success: function (data_serve) {
            
            self.arr_photo = data_serve;
            
            var rnd = tool.randomNum(1, 29);
            self.dy_photo = self.$store.state.url + '/photo/' + self.arr_photo[rnd].photo;
            
          },
          error: function (err) {
            
          }
        });
      },

      receive_coin(vip_rights) {
        var uid = this.$store.state.uid;
        var self = this;
          self.get({
            url: "/App/ReceiveTaskCoin?uid=" + uid +"&task_type=" + vip_rights.task_type +"&coin=" + vip_rights.coin,
            success: function (data) {
              if(data.state == 1){
                vip_rights.state = 3;
                self.coin_left += vip_rights.coin;
                self.act_reload_userinfo();
              }
            },
            error: function (err){}
          });
      },

      //-----微信支付相关---------//
      pay_coin(amount, mny) {

        //启动动画
        this.$loading('支付中...');

        //进行微信支付
        var openid = this.$store.state.openid;
        if (!openid) {
          if ($cookies.isKey('openid')) {
            openid = $cookies.get('openid');
          }
        }

        var order_name = amount + '金币';
        var order_mny = mny;
        var data_order = {
          order_name: order_name,
          order_mny: order_mny,
          openid: openid,
          amount: amount
        };

        this.create_order(data_order);
      },

      create_order(data_order) {
        var order_from = '';
        var client = this.$store.state.client;
        if (client.is_wx) {
          if (data_order.openid) {
            order_from = '微信公众号支付';
          }
          else {
            order_from = '微信环境无openid';
          }
        }
        else {
          order_from = '非微信环境';
          //给弹出提示
          this.Show_GuanzhuWx();
        }

        var self = this;
        var send_data = {
          order_name: data_order.order_name,
          order_mny: data_order.order_mny,
          'uid': self.$store.state.uid,
          'order_type': '购买金币',
          'order_type2':"正常购买",
          'order_from': order_from,
          'comment': data_order.amount,
          'out_id': data_order.openid
        };

        var parm_data = {
          url: '/App/Create_Order',
          data: { 'data': JSON.stringify(send_data) },
          success: function (data_serve) {
            //消掉动画
            self.$loading.close();
            if(data_serve.state != "1") {
               self.$toast.center("订单生成失败,请重新下单");
               return false;
            }

            var data_pay = {
              "body": data_order.order_name,
              "out_trade_no": data_serve.msg,
              "totalMoney": data_order.order_mny * 100,
              "openid": data_order.openid
            }
            self.checkUid();
            self.pay(data_pay);
          },
          error: function (data_serve) {
            //消掉动画
            self.$loading.close();
          }
        }

        self.post(parm_data);
      },

      pay(data) {
        var self = this;
        var strSend = JSON.stringify(data);
        var data = {
          'strSend': strSend,
          success: function (res) {
            //支付成功
            setTimeout(() => {
              var uid = self.$store.state.uid;
              self.act_reload_userinfo({
                uid: uid,
                success: function (u) {
                  self.coin_left = u.coin_left;
                }
              });
            }, 500);
          },
          cancel: function (res) {
          },
          fail: function (res) {
          }
        };


        //检测是否微信环境，是微信环境进行微信支付
        var client = this.$store.state.client;
        if (client.is_wx) {
          this.WxPay(data);
        }
        //-----微信支付相关---------//
      },

      Show_GuanzhuWx() {
        var qrcode_url = require('../../assets/img/qrcode_xhc.jpg');
        var gzh_name = '小火柴';
        //加载dic信息
        var sysdic = this.$store.state.sysdic;
        if(sysdic){
            qrcode_url = sysdic.wx_gzh_qrcode;
            gzh_name = sysdic.wx_gzh_name;
        }
        var h = '<div class="dlg-note">为了保证您的资金安全，当前只支持微信环境下支付，请先关注微信公众号<div>'
          + '<div class="ub ub-ac ub-pc dlg-img"><img src="' + qrcode_url + '" /></div>';
         
        this.$refs.myForm.show(h, {
          type: 'alert',
          confirmText: '微信扫描上方二维码',
          titleText: '温馨提示',
          data: ''
        });
      },

      formBehaviorFun(type, data) {
        if (type == 'clickConfirm') {
         
        }
      },

      checkUid() {
        var uid = this.$store.state.uid;
        //支付检测uid
        if (uid == null || uid == '' || uid == "undefined") {
          var keys = this.$cookies.keys();
          for (var i in keys) {
            this.$cookies.remove(keys[i]);
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.container {
  background-color: #fff;
  .nav-top {
    background-color: #8A61FF;
  }
}
.fade-enter {
    opacity: 0;
    left: 0px;
    top: 3rem;
    width: 0px;
    height: 0px;
  }
  .fade-enter-active {
    transition: all 1s;
  }
  .fade-enter-to {
    opacity: 1;
    left: 40%;
    top: 7rem;
    width: 6rem;
    height: 6rem;
  }
  .fade-leave {
    opacity: 1;
  }
  .fade-leave-active {
    transition: all .5s;
  }
  .fade-leave-to {
    opacity: 0;
    top: 40rem;
    left: 30rem;
    width: 0px;
    height: 0px;
  }
.dy-photo {
    position: fixed;
    left: 40%;
    top: 7rem;
    width: 6rem;
    height: 6rem;
    text-align: center;
    border-radius: 50%;
    img {
      width:100%;
      height: 100%;
      border-radius: 50%
    }
}

.top {
  border-bottom-left-radius: 24%;
  border-bottom-right-radius: 24%;
  padding: 1.1rem 0 0 0;
  background-color: #8A61FF;
  background-image: linear-gradient(to bottom, #8A61FF 13%, #FE9CC0 91%);
  display: flex;
  align-items: center;
  flex-direction: column;
  .info-blcok {
    display: flex;
    width: 86%;
    margin-bottom: 1px;
    .vip-img {
      width: 3rem;
      height: 3rem;
      margin: 0.5rem;
      pointer-events: none;
      border-radius: 50%;
    }
    .info-nick {
      display: flex;
      flex-direction: column;
      margin-left: .3rem;
      span {
        color: #fff;
        display: inline-block;
      }
      .sp-nick {
        font-size: 0.95rem;
        margin: 0.7rem 0 .2rem 0;
      }
      .sp-tip {
        font-size: 0.75rem;
        color: #888;
      }
    }
  }
  .goto {
    margin-top: 0.5rem;
    display: flex;
    padding: 0.8rem 1.5rem;
    align-items: center;
    justify-content: center;
    text-align: left;
    background-color: #ffdfb8;
    border-radius: 0.5rem;
    width: 75%;
    height: 2.6rem;
    border-bottom-left-radius: 22%;
    border-bottom-right-radius: 22%;
    .coin-left-img {
      width: 2.5rem;
      height: 2.5rem;
      margin-right: 0.5rem;
    }
    .coin-left-name {
      font-size: .8rem;
      font-weight: 600;
      background-image: linear-gradient(135deg, red, blue);
      -webkit-background-clip: text;
      color: transparent;
    }
    .coin-left{
      font-size: 1.07rem;
      font-weight: 600;
      background-image: linear-gradient(135deg, red, blue);
      -webkit-background-clip: text;
      color: transparent;
    }
  }
}

.menu-block {
    padding: 0 0.8rem;
    background-color: #fff;
    margin-top: .8rem;
    .menu-item {
    height: 3rem;
    .menu-item-img {
      width: 2rem;
      height: 2rem;
    }
    .menu-item-neme {
      font-size: .95rem;
      margin-left: 0.8rem;
      color: #333;
      .item-fz{
        color: rgb(186, 97, 255);
        font-size: .65rem;
      }
    }
    .menu-item-btn {
      background: linear-gradient( 90deg, #8A61FF, #FE9CC0);
      width: 5rem;
      height: 2rem;
      line-height: 2rem;
      border-radius: 0.3rem;
      color: #fff;
    }
    .menu-item-btn3 {
      background-color: #E9E9E9;
      width: 5rem;
      height: 2rem;
      line-height: 2rem;
      border-radius: 0.3rem;
      color: #898989;
    }
  }
  .menu-line {
    border-top: 1px solid #EEEEEE;
  }
}

.pay-note {
    padding-bottom: 0.5rem;
    margin-top: .5rem;
    margin-left: 1rem;
    color: #999;
    font-size: 0.75rem;
    .tag {
      display: inline-block;
      width: 0.6rem;
      height: 0.6rem;
      background-color: #999;
      margin-right: 0.2rem;
      border-radius: 50%;
    }
}

.container-dark {
    min-height: 100vh;
    background-color: #2F2E33;
    .nav-top {
      background-color: #3c296e;
    }
    .top {
      background-image: linear-gradient(to bottom, #3c296e, #5f3b48);
      .goto {
        background-color: #b67d37;
      }
    }
    .menu-block {
      background-color: #2F2E33;
      .menu-item {
        .menu-item-neme {
          color: #FDFDFD;
        }
      }
    }
    .menu-line {
      border-top: 1px solid #404040;
    }
}
</style>